export const downloadPdf = async (pdfUrl: string, exportedFileName: string) => {
  const response = await fetch(pdfUrl, {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error("Failed to download PDF");
  }

  const blob = await response.blob();

  const url = window.URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = exportedFileName;

  document.body.appendChild(a);
  a.click();

  a.remove();
  window.URL.revokeObjectURL(url);
};
